import mitt, { type Emitter } from 'mitt'
import type { InjectionKey } from 'vue'

// LEGACY: only two events cross the bus during the transition.
// Removed together with the last legacy emitter when views are migrated.
export interface BusEvents {
  reload_ticket_data: undefined
  snackbar: { text: string }
  [key: string | symbol]: unknown
}

export const eventBus = mitt<BusEvents>()

// New-code access path (inject) — legacy Options API components keep using
// this.$event_bus (globalProperties, wired in main.ts).
export const $eventBusKey: InjectionKey<Emitter<BusEvents>> = Symbol('event_bus')

declare module 'vue' {
  interface ComponentCustomProperties {
    $event_bus: Emitter<BusEvents>
  }
}
